import {
  SET_ACTIVE_LOGGER_ASSIGNMENT
} from '../actions';

export default function (state = {}, action) {

  switch(action.type) {
    case SET_ACTIVE_LOGGER_ASSIGNMENT:
      return action.payload;

    default:
      return state;
  }
}